
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/audit-compliance",
      function () {
        return require("private-next-pages/solutions/audit-compliance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/audit-compliance"])
      });
    }
  